import * as React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/Home"; // Assuming you have a Home component
import NotFound from "./components/NotFound";
import CongeDroitParentaux from "./CongeDroitParentaux"; // Assuming you have this component
import CongeTraitementDiffere from "./CongeTraitementDiffere";
import DisciplineChange from "./disciplineChange";
import DisciplinePreference from "./disciplinePreference";
import Maintenance from "./components/Maintenance";
import FormulaireAbsence from "./formulaireAbsence";

// ── Set to true to show the maintenance page site-wide ──
const MAINTENANCE_MODE = false;

function App() {
  if (MAINTENANCE_MODE) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Maintenance />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/formulaireDemandeCongeSansTraitement"
          element={<FormulaireAbsence />}
        />
        <Route
          path="/forumulaireDemandeCongeDroitParentaux"
          element={<CongeDroitParentaux />}
        />
        <Route
          path="/formulaireCongeTraitementDiffere"
          element={<CongeTraitementDiffere />}
        />
        <Route
          path="/formulaireChangementDiscipline"
          element={<DisciplineChange />}
        />
        <Route
          path="/formulairePreferenceDiscipline"
          element={<DisciplinePreference />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
